// Dark Mode Toggle Functionality
class DarkModeToggle {
  constructor() {
    this.storageKey = 'dark-mode-enabled';
    this.darkModeClass = 'dark-mode';
    this.init();
  }

  init() {
    // Load saved preference or default to light mode
    this.isDarkMode = localStorage.getItem(this.storageKey) === 'true' || false;

    // Check system preference if no saved preference
    if (!localStorage.getItem(this.storageKey)) {
      this.isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? true : false;
    }

    this.applyMode();
    this.setupToggleButton();
    this.setupSystemPreferenceListener();
  }

  applyMode() {
    const htmlElement = document.documentElement;

    if (this.isDarkMode) {
      htmlElement.classList.add(this.darkModeClass);
    } else {
      htmlElement.classList.remove(this.darkModeClass);
    }

    this.updateToggleButtonState();
  }

  setupToggleButton() {
    const toggleButton = document.getElementById('dark-mode-toggle');
    if (toggleButton) {
      toggleButton.addEventListener('click', () => this.toggle());
      toggleButton.classList.add('active');
    }
  }

  toggle() {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem(this.storageKey, this.isDarkMode);
    this.applyMode();

    // Dispatch custom event for other components to listen
    window.dispatchEvent(
      new CustomEvent('darkModeToggled', { detail: { isDarkMode: this.isDarkMode } })
    );
  }

  // updateToggleButtonState() { 
  //   const toggleButton = document.getElementById('dark-mode-toggle');
  //   const toggleIcon = document.getElementById('dark-mode-icon');

  //   if (toggleButton) {
  //     toggleButton.setAttribute('aria-pressed', this.isDarkMode);

  //     if (toggleIcon) {
  //       if (this.isDarkMode) {
  //         toggleIcon.classList.remove('icon-moon');
  //         toggleIcon.classList.add('icon-sun');
  //       } else {
  //         toggleIcon.classList.remove('icon-sun');
  //         toggleIcon.classList.add('icon-moon');
  //       }
  //     }
  //   }
  // }
  updateToggleButtonState() {
    const toggleButton = document.getElementById('dark-mode-toggle');
    const toggleIcon = document.getElementById('dark-mode-icon');

    if (!toggleButton) return;

    toggleButton.setAttribute('aria-pressed', this.isDarkMode);

    // ✅ Add/remove classes on button
    toggleButton.classList.toggle('dark', this.isDarkMode);
    toggleButton.classList.toggle('light', !this.isDarkMode);

    // Optional icon switch
    if (toggleIcon) {
      toggleIcon.classList.toggle('icon-sun', this.isDarkMode);
      toggleIcon.classList.toggle('icon-moon', !this.isDarkMode);
    }
  }
  setupSystemPreferenceListener() {
    // Listen for system preference changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!localStorage.getItem(this.storageKey)) {
        this.isDarkMode = e.matches;
        this.applyMode();
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DarkModeToggle();
  });
} else {
  new DarkModeToggle();
}
